module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNDg1IiBoZWlnaHQ9IjI1MDAiIHZpZXdCb3g9Ijk2IDkzIDMyMiAzMjQiPjxwYXRoIGQ9Ik0yNTcgOTNjLTg5IDAtMTYxIDY3LjItMTYxIDE1MCAwIDQ3LjIgMjMuNCA4OS4zIDYwIDExNi44VjQxN2w1NC44LTMwLjNBMTcyIDE3MiAwIDAgMCAyNTcgMzkzYzg5IDAgMTYxLTY3LjIgMTYxLTE1MFMzNDYgOTMgMjU3IDkzem0xNiAyMDJsLTQxLTQ0LTgwIDQ0IDg4LTk0IDQyIDQ0IDc5LTQ0LTg4IDk0eiIgZmlsbD0iIzAwODRmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/facebook-messenger.svg
// module id = 37
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512